module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/brush-bf99486de891fc935d140d5034146194.svg";